import { useEffect, useState, useCallback } from "react";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useAccDistIncoming = (page, pageSize, selectedStatus, filters, searchName, selectedPipelineStage) => {
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalLeads, setTotalLeads] = useState(0);
    const [leadStatusCount, setLeadStatusCount] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [absoluteTotal, setAbsoluteTotal] = useState(0);
    const [pipelineStageCount, setPipelineStageCount] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0); // Add refresh trigger

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
            const leadStatuses = [];
            const pipelineStages = [];
            
            const queryParams = new URLSearchParams({
                page: page.toString(),
                page_size: pageSize.toString(),
            });

            // Handle lead status selection 
            if(selectedStatus) {
                leadStatuses.push(selectedStatus);
            }
            if (filters?.leadStatus?.length) {
                leadStatuses.push(...filters.leadStatus);
            }
            leadStatuses.forEach(status => {
                queryParams.append("lead_status", status);
            });

            // Handle name search
            if(searchName){
                queryParams.append("name", searchName);
                console.log(queryParams);
            }

            // Handle product selection
            if (filters?.products?.length) {
                filters.products.forEach(product => {
                    queryParams.append("products", product);
                });
            }

            // Handle pipeline stage (status) selection
            if (selectedPipelineStage) {
                if(selectedPipelineStage.length === 1){
                    pipelineStages.push(selectedPipelineStage);
                }else{
                    pipelineStages.push(...selectedPipelineStage);
                }
            }
            if (filters?.pipelineStage?.length) {
                pipelineStages.push(...filters.pipelineStage);
            }
            pipelineStages.forEach(stage => {
                queryParams.append("status", stage);
            });

            // Handle lead source selection
            if (filters?.leadSource?.length) {
                filters.leadSource.forEach(source => {
                    queryParams.append("lead_source", source);
                });
            }

            // Handle interest level selection
            if (filters?.interestLevel?.length) {
                filters.interestLevel.forEach(level => {
                    queryParams.append("interest_level", level);
                });
            }

            // Handle region selection
            if (filters?.region?.length) {
                filters.region.forEach(region => {
                    queryParams.append("region", region);
                });
            }

            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_ACCOUNTS.INCOMING_INVENTORY}?${queryParams.toString()}`)
            
            // Assign data to state
            setData(result.data);
            setTotalPages(result.total_pages);
            setTotalLeads(result.total_rows);
            setLeadStatusCount(result.lead_status_count);
            setAbsoluteTotal(result.absolute_total);
            setPipelineStageCount(result.pipeline_stage_count);
        } catch (error) {
            console.error("Error fetching lead inventory:", error);
        } finally {
            setIsLoading(false);
        }
    }, [page, pageSize, selectedStatus, filters, searchName, selectedPipelineStage, refreshKey]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Expose refresh function
    const refresh = useCallback(() => {
        setRefreshKey(prev => prev + 1);
    }, []);

    return { 
        data, 
        totalPages, 
        totalLeads, 
        leadStatusCount, 
        isLoading, 
        absoluteTotal, 
        pipelineStageCount,
        refresh // Add refresh function to return
    };
};